/***
 * 
 * 
 * 平台端需更改main.js以及本页面
 */

let requestUrl = '';
let frontEndRequestUrl = ''; //预览c端的接口
/*测试*/

//  requestUrl = 'https://test1.mamago.com/';// 请求接口的配置：测试接口请求地址配置

// requestUrl = 'https://api.beifamall.com/';// 请求接口的配置：测试接口请求地址配置
// frontEndRequestUrl = 'https://mobile.beifamall.com/';//测试装修c端页面预览入口

requestUrl = 'https://fx-api.jiangxin-food.com/';// 请求接口的配置：接口请求地址配置
frontEndRequestUrl = 'https://fx-wap.jiangxin-food.com';//测试装修c端页面预览入口

export default {
    requestUrl,
    frontEndRequestUrl,
    loading: false, //loading页的开关
    frontendCategoryImage: "/frontend/category/addFrontendCategoryImage" //前台类目图片上传 
};
